export const CONTACT_ENTITIES = {
  emails: {
    type: "emails" as const,
    endpoints: {
      fetch: (customerId: number) => ({
        url: "/api/customer-emails",
        params: { customer_id: customerId },
      }),
      create: {
        url: "/api/customer-emails",
      },
      update: (id: number) => ({
        url: `/api/customer-emails/${id}`,
      }),
      delete: (id: number) => ({
        url: `/api/customer-emails/${id}`,
        params: { soft: false },
      }),
    },
  },

  addresses: {
    type: "addresses" as const,
    endpoints: {
      fetch: (customerId: number) => ({
        url: "/api/customer-addresses",
        params: { customer_id: customerId },
      }),
      create: {
        url: "/api/customer-addresses",
      },
      update: (id: number) => ({
        url: `/api/customer-addresses/${id}`,
      }),
      delete: (id: number) => ({
        url: `/api/customer-addresses/${id}`,
        params: { soft: false },
      }),
    },
  },

  guarantees: {
    type: "guarantees" as const,
    endpoints: {
      fetch: (officeId: number) => ({
        url: "/api/office-guarantees",
        params: { office_id: officeId, show_all: true },
      }),
      create: {
        url: "/api/office-guarantees",
      },
      update: (id: number) => ({
        url: `/api/office-guarantees/${id}`,
      }),
      delete: (id: number) => ({
        url: `/api/office-guarantees/${id}`,
        params: { soft: false },
      }),
    },
  },
} as const;

export type ContactEntityKey = keyof typeof CONTACT_ENTITIES;
